import React from "react";
import VerifinyLogo from "assets/img/verifiny-logo.png";

// Define the Manheim component
const VerifinyX = () => {
	// Function to open the OFAC search URL in a new tab securely
	const openInNewTab = () => {
		const newWindow = window.open(
			"https://dealer.portal.verifiny.com/",
			"_blank",
			"noopener,noreferrer"
		);
		if (newWindow) newWindow.opener = null;
	};

	return (
		<div onClick={openInNewTab}>
			<img src={VerifinyLogo} alt="J.D. POWER" style={{ cursor: "pointer" }} />
		</div>
	);
};

export default VerifinyX;
